export function destinoTrasLogin(rol) {
  if (rol === "admin") return "/empresas";
  if (rol === "conductor") return "/conductor";
  return "/";
}

export function esRutaAdmin(path) {
  const p = path || "";
  if (p === "/" || p === "") return true;
  if (p === "/empresas" || p.startsWith("/empresas/")) return true;
  if (p === "/usuarios" || p.startsWith("/usuarios/")) return true;
  if (p === "/auditoria" || p.startsWith("/auditoria/")) return true;
  return false;
}
